import type { Document } from '@contentful/rich-text-types';
import type { IRichText } from '@belong/types';

export const FRichText = (data: Document, contentId?: string): IRichText => ({
  html: data,
  contentId
});
